import { formRequestEncode } from './utils'

import {
  CODE_SUCCESS_0000,
  CODE_UNLOGIN,
  CODE_0003,
} from './code'

import Toast from '@/components/comToast'

// import globalData from '@/globalData'

const HOST = require(`./host/${process.env.REACT_APP_RUN_MODE}`).default

const axios = require('axios');

axios.defaults.baseURL = HOST;
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default class Http {
  _doQuery(method, path, data = {}, host, config = {}){
    // if (globalData?.channel?.length) {
    //   data.src = globalData.channel
    // }

    //支持post formdata
    let configInit = {
      dealData: true,
      credentials: true,
      cutData: true,
      showMsg: true,
      ...config,
    }
    axios.defaults.withCredentials = configInit.credentials;

    if (method === axios.get) {
      data = {
        params: data,
      }
    } else if (method === axios.post) {
      data = formRequestEncode(data)
    }

    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = host || HOST
      if(config.env === 'pre' ) {
        axios.defaults.baseURL = require(`./host/pre`).default
      }else if(config.env === 'pro') {
        axios.defaults.baseURL = require(`./host/pro`).default
      }
      let { dealData } = configInit

      method(path, data)
      .then(response => {
        if (dealData) {
          processResponseData(response, resolve, reject, configInit)
        } else {
          resolve(response.data)
        }
      })
      .catch(error => {
        if (error?.message?.length && (error.message === 'Network Error' || error.message.indexOf("timeout") !== -1)) {
          //Toast.showMessage('网络异常，稍后再试')
        }
        reject(error)
      })
    })
  }
  get(path, data, host, config) {
    return this._doQuery(axios.get, path, data, host, config)
  }
  post(path, data, host, config){
    return this._doQuery(axios.post, path, data, host, config)
  }
}

export function checkDataSuccess(response) {
  if (response?.resultCode === 0) {
    if (response?.resultData?.code === CODE_SUCCESS_0000) {
      return true
    }
  }

  return false
}

function processResponseData(response, resolve, reject, config) {
  switch (response.status) {
    case 200: {
      let resData = response.data
      // 未登录
      if (resData.resultCode === 3) {
        resData.resultCode = 0
        resData.resultData = {code: CODE_UNLOGIN}
      }
      if (resData.resultCode === 0) {
        resData = resData.resultData || {}
       
        if (resData.result) {
          resData = {...resData, ...resData.result}
        }
        if (resData.resultCode === CODE_SUCCESS_0000 || resData.issuccess === 0) {
          
          if (config.cutData) {
            resolve(resData.data)
          } else {
            resolve(resData)
          }
        } else if (resData.code === CODE_UNLOGIN) {
          //做保护的，防止同时N个接口都返回未登录都跳转登录页太卡的问题
          if (!window.jumpLogined) {
            window.location.href = 'https://plogin.m.jd.com/user/login.action?appid=497&returnurl=' + encodeURIComponent(window.location.href)
            window.jumpLogined = true
          }
          reject({error: resData})
        } else if ([CODE_0003].includes(resData.code)) { //不弹toast
          reject({error: resData})
        } else if (!config.showMsg) {
          reject({error: resData})
        } else {
          console.log(resData)
          if (resData?.info?.length) {
            Toast.showMessage(resData.info)
          } else if (resData?.desc?.length) {
            Toast.showMessage(resData.desc)
          }else if(resData?.success === false) {
            //Toast.showMessage(resData.resultMsg)
          }
          reject({error: resData})
        }
      } else {
        // 您访问的该接口出现异常！Message:error:222_com.jdd.jr.activity.api.bibifanIndexService.getGoldMaeketData(com.jdd.jr.activity.api.base.BaseRequest)
        // resData.resultMsg && resData.resultMsg.length && Toast.showMessage('resData.resultMsg')
        reject({error: resData})
      }
      break;
    }
    default: {
      reject(new Error())
    }
  }
}
